module.exports = __webpack_public_path__ + "img/II-26.1.c984a4c8.svg";